module.exports = __webpack_public_path__ + "static/media/swab-instruction-step05.93036c92.png";